import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-people-of-interest-rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-people-of-interest-rc.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ApplicationCreateService } from "../../../../create-application/shared/application-create.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { ViewApplicationPeopleOfInterestRcConstants } from "./view-application-people-of-interest-rc.constants";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsRcConstants } from "../view-application-details-rc/view-application-details-rc.constants";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
let ViewApplicationPeopleOfInterestRcComponent = class ViewApplicationPeopleOfInterestRcComponent extends ApplicationBaseComponent {
    createApplicationService;
    route;
    routerParamsService;
    recipientSelectService;
    aflaModuleStrategyService;
    viewApplicationService;
    appControllerService;
    changeDetectorRefs;
    peopleOfInterestForm;
    transferorFormControlName = ViewApplicationPeopleOfInterestRcConstants.TRANSFEROR_FORM_CONTROL_NAME;
    transfereeFormControlName = ViewApplicationPeopleOfInterestRcConstants.TRANSFEREE_FORM_CONTROL_NAME;
    conveyancerFormControlName = ViewApplicationPeopleOfInterestRcConstants.CONVEYANCER_FORM_CONTROL_NAME;
    transferorDisableFilterBy = true;
    transferorDisableAdd = true;
    transferorDisableEditing = true;
    transferorShowFields = true;
    transferorIsInternal = false;
    transferorGroups = [];
    transferorLabel = ViewApplicationPeopleOfInterestRcConstants.TRANSFEROR_LABEL;
    transfereeDisableFilterBy = true;
    transfereeDisableAdd = true;
    transfereeDisableEditing = true;
    transfereeShowFields = true;
    transfereeIsInternal = false;
    transfereeGroups = [];
    transfereeLabel = ViewApplicationPeopleOfInterestRcConstants.TRANSFEREE_LABEL;
    copyApplicantToTransfereeLabel = ViewApplicationPeopleOfInterestRcConstants.COPY_APPLICANT_TO_TRANSFEREE_LABEL;
    conveyancerDisableFilterBy = true;
    conveyancerDisableAdd = false;
    conveyancerDisableEditing = true;
    conveyancerShowFields = true;
    conveyancerIsInternal = false;
    conveyancerGroups = [];
    conveyancerLabel = ViewApplicationPeopleOfInterestRcConstants.CONVEYANCER_LABEL;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    patchRecipientDataSubscription;
    getStepMetaObservableSubscription;
    constructor(createApplicationService, route, routerParamsService, recipientSelectService, aflaModuleStrategyService, viewApplicationService, appControllerService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.recipientSelectService = recipientSelectService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        this.getMetadata();
    }
    handleRouteChange() {
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        try {
            this.transferorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.transferorGroup);
            this.transfereeGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.transfereeGroup);
            this.conveyancerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.conveyancerGroup);
            this.getApplicationData();
            this.changeDetectorRefs.markForCheck();
        }
        catch (e) {
            this.appControllerService.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        this.peopleOfInterestForm = this.aflaModuleStrategyService.form.get("peopleOfInterestForm");
        this.changeDetectorRefs.detectChanges();
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    getApplicationComplete(applicationData) {
        // set transferor
        const transferorControl = this.peopleOfInterestForm.get(this.transferorFormControlName);
        transferorControl.enable();
        transferorControl.setValue(applicationData.transferor[0]);
        transferorControl.disable();
        // set transferee
        const transfereeControl = this.peopleOfInterestForm.get(this.transfereeFormControlName);
        transfereeControl.enable();
        transfereeControl.setValue(applicationData.transferee[0]);
        transfereeControl.disable();
        // set transferor
        const conveyancerControl = this.peopleOfInterestForm.get(this.conveyancerFormControlName);
        conveyancerControl.enable();
        conveyancerControl.setValue(applicationData.conveyancer[0]);
    }
    getApplicationData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `transferor($expand=groups),transferee($expand=groups),conveyancer($expand=groups)`,
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe({
            next: (returnValue) => {
                const applicationData = returnValue.value[0];
                this.getApplicationComplete(applicationData);
            },
            error: err => {
                this.appControllerService.handleServerErrorMessage("people of interest", err, CRUDOperation.Get);
            }
        });
    }
    onBtnSaveClicked() {
        if (this.peopleOfInterestForm.valid) {
            let conveyancer;
            const conveyancerFormControlValue = this.peopleOfInterestForm.get("conveyancer").value;
            conveyancer = RecipientUtils.removeRecipientProperties(conveyancerFormControlValue);
            this.patchRecipientDataSubscription =
                this.recipientSelectService.patchRecipientData(conveyancer, conveyancer.id).subscribe({
                    next: () => {
                        this.appControllerService.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                    },
                    error: (error) => {
                        this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsRcConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: RecipientSelectService },
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationPeopleOfInterestRcComponent = __decorate([
    Component({
        selector: "app-view-application-people-of-interest-rc",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationPeopleOfInterestRcComponent);
export { ViewApplicationPeopleOfInterestRcComponent };
